<template>
  <v-dialog :value="value" max-width="560" @input="$emit('input', $event)">
    <v-card v-if="falta">
      <v-card-title class="d-flex align-center justify-space-between">
        <span>Falta Justificada</span>
        <v-chip small :color="corStatus(falta.status)" dark>{{ falta.status }}</v-chip>
      </v-card-title>

      <v-divider />

      <v-card-text class="pt-4">
        <v-row dense>
          <v-col cols="12" sm="6">
            <div class="caption text--secondary">Colaborador</div>
            <div class="body-2">{{ falta.colaborador?.name || "—" }}</div>
          </v-col>
          <v-col cols="12" sm="6">
            <div class="caption text--secondary">Período</div>
            <div class="body-2">
              {{ formatarData(falta.data_inicio) }}
              <span v-if="falta.data_fim"> até {{ formatarData(falta.data_fim) }}</span>
            </div>
          </v-col>
          <v-col cols="12">
            <div class="caption text--secondary mt-2">Motivo</div>
            <div class="body-2">{{ falta.motivo || "—" }}</div>
          </v-col>
          <v-col v-if="falta.observacao" cols="12">
            <div class="caption text--secondary mt-2">Observação do colaborador</div>
            <div class="body-2">{{ falta.observacao }}</div>
          </v-col>
          <v-col v-if="falta.documento" cols="12">
            <div class="caption text--secondary mt-2">Documento</div>
            <v-btn small outlined color="primary" @click="abrirDocumento">
              <v-icon left small>mdi-paperclip</v-icon>
              Ver documento
            </v-btn>
          </v-col>
        </v-row>

        <template v-if="falta.status !== 'pendente'">
          <v-divider class="my-4" />
          <v-row dense>
            <v-col cols="12" sm="6">
              <div class="caption text--secondary">Avaliador</div>
              <div class="body-2">{{ falta.avaliador?.name || "—" }}</div>
            </v-col>
            <v-col cols="12" sm="6">
              <div class="caption text--secondary">Avaliado em</div>
              <div class="body-2">{{ formatarData(falta.avaliado_em) }}</div>
            </v-col>
            <v-col v-if="falta.observacao_avaliador" cols="12">
              <div class="caption text--secondary mt-2">Observação do avaliador</div>
              <div class="body-2">{{ falta.observacao_avaliador }}</div>
            </v-col>
          </v-row>
        </template>

        <template v-if="falta.status === 'pendente'">
          <v-divider class="my-4" />
          <div class="subtitle-2 mb-2">Avaliar solicitação</div>
          <v-textarea
            v-model="observacaoAvaliador"
            label="Observação (opcional)"
            outlined
            dense
            rows="3"
            hide-details
            class="mb-3"
          />
          <div class="d-flex gap-2">
            <v-btn color="success" :loading="salvando" @click="avaliar('aprovado')">
              <v-icon left small>mdi-check</v-icon>
              Aprovar
            </v-btn>
            <v-btn color="error" :loading="salvando" class="ml-2" @click="avaliar('reprovado')">
              <v-icon left small>mdi-close</v-icon>
              Reprovar
            </v-btn>
          </div>
        </template>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text @click="$emit('input', false)">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "FaltaJustificadaDetailDialog",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    falta: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      observacaoAvaliador: "",
      salvando: false,
    };
  },
  watch: {
    value(v) {
      if (v) this.observacaoAvaliador = "";
    },
  },
  methods: {
    async avaliar(status) {
      try {
        this.salvando = true;
        await this.$services.colaboradorPontosService.avaliarFaltaJustificada(this.falta.id, {
          status,
          observacao_avaliador: this.observacaoAvaliador || null,
        });
        this.$toast.success(status === "aprovado" ? "Falta aprovada" : "Falta reprovada");
        this.$emit("avaliado");
        this.$emit("input", false);
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.salvando = false;
      }
    },
    async abrirDocumento() {
      try {
        await this.$services.colaboradorPontosService.abrirDocumentoFalta(this.falta.id);
      } catch (error) {
        this.$handleError(error);
      }
    },
    corStatus(status) {
      return { pendente: "orange", aprovado: "green", reprovado: "red" }[status] || "grey";
    },
    formatarData(data) {
      if (!data) return "—";
      const [ano, mes, dia] = String(data).split("T")[0].split("-");
      return `${dia}/${mes}/${ano}`;
    },
  },
};
</script>
